module.exports = __webpack_public_path__ + "img/1f63f.ab6835d.svg";